import React from 'react';
import Chips from "../Chips";

const SelectChips = function (props) {

    const removeTag = (key) => {
        if(props.removetag)
            props.removetag(key);
    }

    return (
        props.show && props.options && props.allChecked ? (
            <div>
                {
                    props.options.map((item, key) => {
                        if(item.checked) {
                            return (
                                <Chips key={item.key} accessKey={item.key} removetag={removeTag}>{item.label}</Chips>
                            )
                        }
                    })
                }
            </div>
        ) : null
    );
}

export default SelectChips;
